import { FC } from "react";
import { Dialog } from "@smartsuite/react-ui/lib/components/modals/Dialog";
import { ModalOverlay } from "@smartsuite/react-ui/lib/components/modals/ModalOverlay/ModalOverlay";

interface DeleteConfirmationDialogProps {
  isOpened: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

export const DeleteConfirmationDialog: FC<DeleteConfirmationDialogProps> = ({
  isOpened,
  onConfirm,
  onCancel,
}) => {
  return (
    <ModalOverlay active={isOpened} onClose={onCancel}>
      <Dialog.Wrapper type="warning" onCancel={onCancel}>
        <Dialog.Image background="red" url="/question.svg" />
        <Dialog.Header>
          <Dialog.Header.Heading text="Are you sure?" />
          <Dialog.Header.Description text="Are you sure that you want to delete the view?" />
        </Dialog.Header>
        <Dialog.Footer>
          <Dialog.Footer.CancelButton text="No, Cancel" onClick={onCancel} />
          <Dialog.Footer.ConfirmButton
            warningBackground={true}
            text="Yes, Delete View"
            onClick={() => {
              onConfirm()
                .then(() => window.parent.postMessage("close", "*"))
                .catch(console.error);
            }}
          />
        </Dialog.Footer>
      </Dialog.Wrapper>
    </ModalOverlay>
  );
};
